import { parseGraphQLId } from "@/lib/graphql/id";
import { ID_ALIAS_KIND_PREFIXES } from "./prefixes";

const DISPLAY_REDACTION = "[resource]";
// 探索自体を制限し、巨大添付の途中を短い ID として切り取らない。
const GRAPHQL_ID_CANDIDATE_PATTERN =
  /(?<![A-Za-z0-9+/])[A-Za-z0-9+/]{20,512}={0,2}(?![A-Za-z0-9+/=])/g;
const URL_ENCODED_GRAPHQL_ID_CANDIDATE_PATTERN =
  /(?<![A-Za-z0-9%])(?:[A-Za-z0-9]|%2[BbFf]){20,512}(?:%3[Dd]){0,2}(?![A-Za-z0-9%])/g;
const ALIAS_PREFIXES = [...new Set(Object.values(ID_ALIAS_KIND_PREFIXES))];
const ALIAS_CANDIDATE_PATTERN = new RegExp(
  `\\b(?:${ALIAS_PREFIXES.join("|")})_(?:[0-9a-f]{6}|[0-9a-f]{12})(?![A-Za-z0-9_])`,
  "g",
);

/**
 * canonical ID を保持する reasoning 保存形式は変えず、任意開示 UI だけを人向けにする。
 * 現行 alias と過去履歴の短い alias の両方を隠し、ユーザーへ内部参照を露出しない。
 */
export function redactInternalResourceReferencesForDisplay(
  text: string,
): string {
  const encodedRedacted = text.replace(
    URL_ENCODED_GRAPHQL_ID_CANDIDATE_PATTERN,
    (candidate) =>
      parseGraphQLId(decodeURIComponent(candidate))
        ? DISPLAY_REDACTION
        : candidate,
  );
  const idRedacted = encodedRedacted.replace(
    GRAPHQL_ID_CANDIDATE_PATTERN,
    (candidate) =>
      candidate
        .split("/")
        .map((segment) =>
          parseGraphQLId(segment) ? DISPLAY_REDACTION : segment,
        )
        .join("/"),
  );
  return idRedacted.replace(ALIAS_CANDIDATE_PATTERN, DISPLAY_REDACTION);
}
